import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  ViewChild,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MaterialModule } from '../../../../../shared/material/material.module';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import {
  CouncilProfession,
} from '../../../../../core/generated';
import { CouncilProfessionControllerService } from '../../../../../core/generated/api/councilProfessionController.service';
import { DialogCouncilProfessionFormComponent } from './dialog-council-profession-form.component';
import { TipsDialogComponent } from '../../../../../shared/tips/tips-dialog.component';
import { ContainerComponent } from '../../../../../shared/container/container.component';

@Component({
  selector: 'app-council-profession',
  standalone: true,
  imports: [MaterialModule, ContainerComponent],
  templateUrl: './council-profession.component.html',
  styleUrl: './council-profession.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CouncilProfessionComponent {
  private councilProfessionService = inject(CouncilProfessionControllerService);
  public dialog = inject(MatDialog);
  private deviceService = inject(DeviceDetectorService);
  private cd = inject(ChangeDetectorRef);

  @Input()
  councilProfessions: CouncilProfession[] = [];
  @Input()
  councilId!: number;
  @Input()
  councilGroup!: string;

  @ViewChild(MatTable) table!: MatTable<CouncilProfession>;
  displayedColumnsCouncilProfession: string[] = [
    'certifiedHubMedical',
    'professionName',
    'specialty',
    'activityArea',
    'expand',
  ];

  isMobile = this.deviceService.isMobile();
  expandedElementCouncilProfession: CouncilProfession | null = null;

  addProfession() {
    if (this.councilProfessions === null) {
      this.councilProfessions = [];
    }
    const dialogRef = this.dialog.open(DialogCouncilProfessionFormComponent, {
      data: {
        councilProfessions: this.councilProfessions,
        councilId: this.councilId,
        councilGroup: this.councilGroup,
      },
    });

    dialogRef.afterClosed().subscribe((result: CouncilProfession[]) => {
      if (result) {
        this.councilProfessions = result;
        this.openTipDialog('Profissão adicionada com sucesso', null);

      }

      this.cd.detectChanges();
      this.table.renderRows();


    });
  }

  deleteProfession(councilProfessionSelected: CouncilProfession) {
    if (councilProfessionSelected.id) {
      this.councilProfessionService
        .deleteById13(councilProfessionSelected.id)
        .subscribe((cpResponse) => {
          if (this.councilProfessions && councilProfessionSelected.id) {
            this.councilProfessions = this.councilProfessions.filter(
              (item: CouncilProfession) =>
                item.id != councilProfessionSelected.id
            );
          }
          this.table.renderRows();
          this.cd.detectChanges();
        });
    }
  }
  openTipDialog(title: string, routerlink: string | null) {
    this.dialog.open(TipsDialogComponent, {
      data: { title, routerlink },
    });
  }
}
